// extracted by mini-css-extract-plugin
export var background = "layout-module--background--fab24";
export var boardborder = "layout-module--boardborder--b15a6";
export var body = "layout-module--body--6b265";
export var button = "layout-module--button--36b8e";
export var container = "layout-module--container--78b04";
export var footertext = "layout-module--footertext--51eb8";
export var heading = "layout-module--heading--f158c";
export var leftfacing = "layout-module--leftfacing--d4d0b";
export var navLinkText = "layout-module--nav-link-text--69cda";
export var navbar = "layout-module--navbar--d1c06";
export var responsiveiframecontainer = "layout-module--responsiveiframecontainer--7fc82";
export var siteTitle = "layout-module--site-title--e4dea";